import * as runtime from '@/api/runtime'
import {
  BatchStatisticsPageLoadRequest,
  BatchStatisticsPageLoadRequestToJSON
} from '@/api'
import {
  BatchSchoolStatisticsBestReaderRequest,
  BatchSchoolStatisticsBestReaderRequestToJSON
} from '@/api/models/batch/BatchSchoolStatisticsBestReaderRequest'
import {
  BatchSchoolStatisticsBestReaderSelectItemResult,
  BatchSchoolStatisticsBestReaderSelectItemResultFromJSON
} from '@/api/models/batch/BatchSchoolStatisticsBestReaderSelectItemResult'

export class BatchSchoolStatisticsBestReaderApi extends runtime.BaseAPI {
  /**
   * 画面初期表示時の検索状態取得
   * @param request
   */
  async readInitialPattern(
    request: BatchStatisticsPageLoadRequest
  ): Promise<BatchSchoolStatisticsBestReaderSelectItemResult> {
    const response = await this.requestGet(
      `/batch/statistics/search_initial_condition`,
      BatchStatisticsPageLoadRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BatchSchoolStatisticsBestReaderSelectItemResultFromJSON(jsonValue)
    ).value()
  }

  /**
   * 帳票作成
   * @param request
   */
  async createBestReader(
    request: BatchSchoolStatisticsBestReaderRequest
  ): Promise<number> {
    const response = await this.requestPost(
      `/batch/school-statistics/best-reader`,
      BatchSchoolStatisticsBestReaderRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }
}
